import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, map } from 'rxjs';

export interface FilterValuesResponse {
  companies: { id: number; name: string }[];
  departments: { id: number; name: string; code: number }[];
  workerTypes: { id: number; name: string }[];
  shifts: { id: number; name: string }[];
  payGroups: { id: number; name: string }[];
  workOrderNumbers: { id: number; won: string }[];
  scheduledDays: { name: string; value: string }[];
  scheduledHours: { id: number; name: string; timeZoneId: string }[];
}

export interface Employee {
  employeeNumber: string;
  id: number;
  firstName: string;
  lastName: string;
  employeeStatus: string;
  // include other fields if needed
}

@Injectable({
  providedIn: 'root'
})
export class EmployeeValidationService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  /** Fetch all validation data in a single request */
  getFilterValues(): Observable<FilterValuesResponse> {
    return this.http.get<{ status: string; data: FilterValuesResponse }>(
      `${this.baseUrl}/api/users/filter-values`
    ).pipe(
      map(res => res.data)
    );
  }

  /** Fetch all employees with unlimited page size */
  getEmployees(): Observable<Employee[]> {
    return this.http.get<{ status: string; data: Employee[] }>(
      `${this.baseUrl}/api/users?pageSize=10000`
    ).pipe(
      map(res => res.data)
    );
  }
}
